



export function kmlExport(uuid, graphLatLng, headlandExterior, headlandInterior, sequence, mainPaths, sidePaths) {

    let result = '<?xml version="1.0" encoding="UTF-8"?>'
    result += '<kml xmlns="http://www.opengis.net/kml/2.2">';
    result += '<Document>';
    result += '<name>KML Export</name>';
    result += '<uuid>' + uuid + '</uuid>';
    result += '<lastChange>' + Math.round(Date.now() / 1000) + '</lastChange>';

    result += '<Style id="yellowLine">';
    result += '<LineStyle>';
    result += '<color>7f00ffff</color>';
    result += '<width>4</width>';
    result += '</LineStyle>';
    result += '</Style>';

    result += '<Style id="blackLine">';
    result += '<LineStyle>';
    result += '<color>000000ff</color>';
    result += '<width>4</width>';
    result += '</LineStyle>';
    result += '</Style>';

    result += '<Style id="blueLine">';
    result += '<LineStyle>';
    result += '<color>4444ffff</color>';
    result += '<width>4</width>';
    result += '</LineStyle>';
    result += '</Style>';


    result += '<Placemark>';
    result += '<name>HeadlandExteriorPolygon</name>';
    result += '<styleUrl>#blackLine</styleUrl>';
    result += '<LineString><extrude>1</extrude><tessellate>1</tessellate>';
    // result += '<altitudeMode>clampToGround</altitudeMode>';
    result += '<coordinates>';

    for (let i = 0; i < headlandExterior.length; ++i) {
        const point = headlandExterior[i];
        result += '' + point.lng + ',' + point.lat + ',0\n';
    }

    result += '</coordinates>';
    result += '</LineString>';
    result += '</Placemark>';

    result += '<Placemark>';
    result += '<name>HeadlandInteriorPolygon</name>';
    result += '<styleUrl>#blueLine</styleUrl>';
    result += '<LineString><extrude>1</extrude><tessellate>1</tessellate>';
    // result += '<altitudeMode>clampToGround</altitudeMode>';
    result += '<coordinates>';

    for (let i = 0; i < headlandInterior.length; ++i) {
        const point = headlandInterior[i];
        result += '' + point.lng + ',' + point.lat + ',0\n';
    }

    result += '</coordinates>';
    result += '</LineString>';
    result += '</Placemark>';


    for (let i = 0; i < graphLatLng.nodesLatLng.length; ++i) {
        const node = graphLatLng.nodesLatLng[i];
        result += '<Placemark>';
        result += '<name>n_' + i + '</name>';
        result += '<Point>';
        result += '<coordinates>' + node.lng + ',' + node.lat + ',0</coordinates>';
        result += '</Point>';
        result += '</Placemark>';
    }

    for (let i = 0; i < graphLatLng.pathsLatLng.length; ++i) {
        const path = graphLatLng.pathsLatLng[i];
        result += '<Placemark>';
        result += '<name>p_' + i + '</name>';
        result += '<styleUrl>#yellowLine</styleUrl>';
        result += '<LineString><extrude>1</extrude><tessellate>1</tessellate>';
        result += '<coordinates>';

        for (let j = 0; j < path.length; ++j) {
            const node = path[j];
            result += '' + node.lng + ',' + node.lat + ',0\n';
        }

        result += '</coordinates>';
        result += '</LineString>';
        result += '</Placemark>';
    }


    for (let i = 0; i < graphLatLng.edges.length; ++i) {
        const edge = graphLatLng.edges[i];
        result += '<edge>';
        result += '<name>e_' + i + '</name>';
        result += '<index>' + edge[0] + '</index>';
        result += '<index>' + edge[1] + '</index>';
        result += '</edge>';
    }


    if (sequence) {
        result += '<sequence>';
        sequence.forEach(s => {
            result += '<index>' + s + '</index>';
        });
        result += '</sequence>';
    }

    mainPaths.forEach(indices =>  {
        if (indices.length > 1) {
            result += "<mainPath>"
            indices.forEach(idx => {
                result += "<index>" + idx + "</index>";
            });
            result += "</mainPath>"
        }
    });

    sidePaths.forEach(indices =>  {
        result += "<sidePath>"
        indices.forEach(idx => {
            result += "<index>" + idx + "</index>";
        });
        result += "</sidePath>"
    });

    result += '</Document>';
    result += '</kml>'


    return result;
}